import gql from 'graphql-tag';

export const GET_CROSSSECTION_DATA = gql`
query($id: String!) {
    crosssection(id: $id) {
      traffic_situation {
        trafficSituation
        timestamp
      }
      traffic_data {
        qKfzG
        qLkwG
        qPkwG
        vKfzG
        vLkwG
        vPkwG
        timestamp
      }
    }
}
`;